import { TableArrowRightIcon } from './TableArrowRightIcon';

/**
 * author: Michael Irigoyen
 * id A4A68FD7-82B8-4BE8-8110-DA54D1A888D4
 * name table-arrow-right
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-arrow-right.svg
 * tags
 */
export const TableExportIcon = TableArrowRightIcon;
export default TableExportIcon